<template>
  <div class="quality-test-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info :work-order="wkDetailInfo"></work-order-base-info>
        <work-order-user-info :work-order="wkDetailInfo"></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          :always-show-more-info="true"
          @refresh="getWkOrderInfo"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12">
        <work-order-card :isShowHeader="false">
          <work-order-tool
            slot="card-body"
            :work-order="wkDetailInfo"
            @refresh="getWkOrderInfo"
          ></work-order-tool>
        </work-order-card>
        <el-card style="margin-bottom: 10px">
          <el-tabs>
            <el-tab-pane label="质检">
              <div class="quality-test-detail-right">
                <div class="quality-content">
                  <div class="score-statistical">
                    <span>质检项：</span>
                    <span>
                      合计得分：
                      <span class="color-green">{{ totalScore }}</span>
                    </span>
                  </div>
                  <el-table
                    :data="qaTestDetailInfoVos"
                    :show-header="false"
                    :cell-style="cellStyle"
                    border
                  >
                    <el-table-column prop="qaTestTypeName" width="210">
                      <template slot-scope="{ row }">
                        <span>{{ row.qaTestTypeName }}</span>
                        <span v-if="row.newFlag" style="color: #3498db"
                          >(新增质检项)</span
                        >
                        <span v-if="row.deleteFlag" style="color: #e74c3c"
                          >(该质检项已被删除)</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="qaTestScore" width="209">
                      <template slot-scope="{ row }">
                        <el-input
                          v-model.number="row.qaTestScore"
                          :min="0"
                          :max="row.maxScore"
                          @input="handleScoreInput(row)"
                          @keydown.native="handleInputLimit"
                          type="number"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                  <p>*质检评语：</p>
                  <el-input
                    type="textarea"
                    :rows="5"
                    resize="none"
                    show-word-limit
                    :maxlength="500"
                    placeholder="请输入质检评语"
                    v-model="qualityDetail"
                  ></el-input>
                  <div class="button-box">
                    <el-button
                      @click="submit"
                      class="my-btn ml-16"
                      size="small"
                      type="primary"
                    >
                      提交
                    </el-button>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog title="重新打开" :visible.sync="openVisible">
      <el-form :model="form" :rules="rules" ref="openform">
        <el-form-item label="请输入重新打开原因" prop="openReason">
          <el-input v-model="form.openReason" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="openVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="reOpenNow"
          :loading="openLoading"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="强制关闭" :visible.sync="closeVisible">
      <el-form :model="closeForm" :rules="closeRules" ref="closeform">
        <el-form-item label="请输入强制关闭原因" prop="closeReason">
          <el-input
            v-model="closeForm.closeReason"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="closeVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="closeNow"
          size="small"
          :loading="closeLoading"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "workmange.workQuality.detail",
  components: {},
  data() {
    return {
      tableData: [],
      qualityDetail: "",
      wkDetailInfo: {},
      qaTestDetailInfoVos: [],
      totalScore: 0,
      openVisible: false,
      form: {
        openReason: "",
      },
      rules: {
        openReason: [
          {
            required: true,
            message: "请输入重新打开原因",
            trigger: "blur",
          },
        ],
      },
      closeForm: {
        closeReason: "",
      },
      closeVisible: false,
      closeRules: {
        closeReason: [
          {
            required: true,
            message: "请输入强制关闭原因",
            trigger: "blur",
          },
        ],
      },
      closeLoading: false,
      openLoading: false,
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    id() {
      return this.$route.query.id;
    },
  },
  activated() {
    this.getQaTestByWorkOrderId().then(() => {
      this.maxScore();
    });
    this.getWkOrderInfo();
  },
  deactivated() {
    this.resetData();
  },
  methods: {
    getWkOrderInfo() {
      return api.work.getWorkDetail({ id: this.id }).then((res) => {
        const data = res.data.data;
        this.wkDetailInfo = data;
      });
    },
    resetData() {
      this.tableData = [];
      this.qualityDetail = "";
      this.wkDetailInfo = {};
      this.qaTestDetailInfoVos = [];
      this.totalScore = 0;
    },
    remind() {
      api.workmanage.remind(this.wkOrderId).then((res) => {
        this.$message.success("提醒成功！");
        this.getQaTestByWorkOrderId().then(() => {
          this.maxScore();
        });
      });
    },
    reOpen() {
      this.openVisible = true;
    },
    close() {
      this.closeVisible = true;
    },
    reOpenNow() {
      this.$refs.openform.validate((valid) => {
        if (valid) {
          api.workmanage.checkOpen(this.$route.query.wkOrderId).then((res) => {
            if (res.data.data.status) {
              this.postOpen();
            } else {
              this.$confirm(res.data.data.alert)
                .then(() => {
                  this.postOpen();
                })
                .catch(() => {});
            }
          });
        }
      });
    },
    postOpen() {
      this.openLoading = true;
      let args = {
        openReason: this.form.openReason,
        workOrderId: this.wkOrderId,
      };
      api.workmanage
        .reOpen(args)
        .then((res) => {
          this.openVisible = false;
          this.getQaTestByWorkOrderId().then(() => {
            this.maxScore();
          });
          this.closeForm = { closeReason: "" };
          this.form = { openReason: "" };
          this.getWkOrderInfo();
        })
        .finally(() => {
          this.openLoading = false;
        });
    },
    closeNow() {
      this.$refs.closeform.validate((valid) => {
        if (valid) {
          this.closeLoading = true;
          let args = {
            closeReason: this.closeForm.closeReason,
            workOrderId: this.wkOrderId,
          };
          api.workmanage
            .close(args)
            .then((res) => {
              this.closeVisible = false;
              this.$refs.closeform.resetFields();
              this.getQaTestByWorkOrderId().then(() => {
                this.maxScore();
              });
              this.getWkOrderInfo();
            })
            .finally(() => {
              this.closeLoading = false;
            });
        }
      });
    },
    handleScoreInput(row) {
      this.totalScore = 0;
      if (row.qaTestScore < 0 || row.qaTestScore === "") {
        row.qaTestScore = 0;
      } else if (row.qaTestScore > row.maxScore) {
        row.qaTestScore = row.maxScore;
      }
      for (let item of this.qaTestDetailInfoVos) {
        if (!item.deleteFlag) {
          this.totalScore += item.qaTestScore;
        }
      }
    },
    handleInputLimit(e) {
      const limitChar = ["e", ".", "-", "+"];
      if (limitChar.includes(e.key)) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    maxScore() {
      return api.workmanage
        .maxScore({ wkOrderId: this.wkOrderId })
        .then((res) => {
          for (let item1 of this.qaTestDetailInfoVos) {
            let flag = true;
            for (let item2 of res.data.data) {
              if (item1.qaTestTypeId == item2.id) {
                item1.maxScore = item2.score;
                item1.qaTestTypeName = `${item1.qaTestTypeName}(${item1.maxScore})`;
                flag = false;
              }
            }
            if (flag) {
              item1.qaTestTypeName = `${item1.qaTestTypeName}(${item1.qaTestTypeScore})`;
              item1.deleteFlag = true;
            }
          }
          for (let item2 of res.data.data) {
            let flag = true;
            for (let item1 of this.qaTestDetailInfoVos) {
              if (item1.qaTestTypeId == item2.id) {
                flag = false;
              }
            }
            if (flag) {
              const qaTestDetailInfo = {
                qaTestTypeId: item2.id,
                maxScore: item2.score,
                qaTestTypeName: `${item2.qaTestTypeName}(${item2.score})`,
                qaTestScore: 0,
                newFlag: true,
              };
              this.qaTestDetailInfoVos.push(qaTestDetailInfo);
            }
          }
          this.qaTestDetailInfoVos = this.qaTestDetailInfoVos.slice(0);
        });
    },
    getQaTestByWorkOrderId() {
      return api.workmanage
        .getQaTestByWorkOrderId(this.wkOrderId)
        .then((res) => {
          const data = res.data.data;
          this.qaTestDetailInfoVos = data.qaTestDetailInfoVos;
          this.qualityDetail =
            data.qaTestComments == null ? "" : data.qaTestComments;
          this.totalScore = data.qaTestScore;
        })
        .catch((err) => {});
    },
    submit() {
      if (!this.qualityDetail.trim()) {
        this.$message.warning("请填写评语！");
        return;
      }
      const tempData = {
        qaTestComments: this.qualityDetail,
        qaTestDictAos: [],
        wkOrderId: this.wkOrderId,
      };
      for (let item of this.qaTestDetailInfoVos) {
        if (!item.deleteFlag) {
          tempData.qaTestDictAos.push({
            qaTestTypeId: item.qaTestTypeId,
            score: item.qaTestScore,
            qaTestType: item.qaTestType,
          });
        }
      }
      api.workmanage
        .createQaTestDetail(tempData)
        .then((res) => {
          if (res.data.success) {
            this.$message.success("完成质检！");
            this.getQaTestByWorkOrderId();
            this.qualityDetail = "";
            this.$router.push({
              name: "workmange.workQuality.list",
            });
          }
        })
        .catch((err) => {});
    },
    timeFormat(date) {
      return new Date(+new Date(date) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    statusFormat(val) {
      switch (val) {
        case 0:
          return "待处理";
        case 1:
          return "已处理";
        case 2:
          return "已关闭";
        case 3:
          return "已驳回";
        case 4:
          return "处理中";
        default:
          return "";
      }
    },
    cellStyle({ columnIndex }) {
      if (columnIndex === 0) {
        return "background:#f2f2f2"; //rgb(105,0,7)
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.quality-test-detail {
  width: 100%;

  .quality-test-detail-left {
    width: 1160px;

    .detail-header {
      width: 100%;
      background: #fff;
    }

    .record {
      width: 100%;

      .record-container {
        padding-left: 18px;
      }
    }
  }

  .quality-test-detail-right {
    width: 500px;
    box-sizing: border-box;
    background: #fff;

    .detail-right-title {
      width: 100%;
      font-size: 18px;
      line-height: 25px;
      padding: 24px 20px 19px;
      border-bottom: 1px solid #e2e2e2;
      box-sizing: border-box;
    }

    .quality-content {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;

      .score-statistical {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        line-height: 22px;
        color: #666;
        padding: 20px 0;
      }

      .button-box {
        width: 100%;
        text-align: center;
        margin-top: 40px;
      }

      /deep/ .el-table__body tr,
      .el-table__body td {
        padding: 0;
        height: 40px;
      }
    }
  }
}
</style>
